import type { AppState } from "../shared/types";
export const openingIdeas = {
  italian: {
    title: "The Italian: pressure with development",
    text: "After e4 e5, Nf3 Nc6 and Bc4, the bishop points at f7. Black is to move. White usually wants a safe king and a useful central break; a quiet d3 setup and an earlier d4 break create different plans.",
    question: "What would you need to prepare before playing d4?",
  },
  sicilian: {
    title: "The Sicilian: an unbalanced center",
    text: "After 1.e4 c5, White has a central foothold and Black challenges d4 from the flank. In Open Sicilian structures, White often develops quickly while Black looks for queenside counterplay. These are plans to investigate, not rules that replace calculation.",
    question: "Compare Nf3 and c3. How would you support a later d4 push?",
  },
  "queens-gambit": {
    title: "The Queen’s Gambit: ask a central question",
    text: "After 1.d4 d5 2.c4, White challenges Black’s d5 pawn. If Black takes, development and central control matter more than immediately trying to regain the pawn. Explore how e3 opens the bishop’s route to c4.",
    question:
      "If Black captures on c4, which developing move also helps recover the pawn?",
  },
  "ruy-lopez": {
    title: "The Ruy Lopez: indirect central pressure",
    text: "After e4 e5, Nf3 Nc6 and Bb5, White applies pressure to the knight on c6. The bishop does not simply win the e5 pawn: Black has tactical resources. Develop and castle, then compare ways to maintain tension in the center.",
    question:
      "Why is trading on c6 and taking e5 not automatically a free pawn? Test Black’s replies.",
  },
} as const;
export function mirrorPerspective(fen: string): string {
  const fields = fen.split(" ");
  const swap = (c: string) =>
    /[a-z]/.test(c) ? c.toUpperCase() : /[A-Z]/.test(c) ? c.toLowerCase() : c;
  fields[0] = fields[0]
    .split("/")
    .reverse()
    .map((rank) => [...rank].map(swap).join(""))
    .join("/");
  fields[1] = fields[1] === "w" ? "b" : "w";
  const rights = [...fields[2]].map(swap).join("");
  fields[2] =
    "KQkq"
      .split("")
      .filter((c) => rights.includes(c))
      .join("") || "-";
  if (fields[3] !== "-")
    fields[3] = fields[3][0] + String(9 - Number(fields[3][1]));
  fields[5] = "1";
  return fields.join(" ");
}
export function mirrorMove(move: string): string {
  return (
    move[0] +
    String(9 - Number(move[1])) +
    move[2] +
    String(9 - Number(move[3])) +
    move.slice(4)
  );
}
export function studioContext(state: AppState) {
  return state.studio?.gameId === state.activeGameId ? state.studio : null;
}
